import { TransferWorkshopStoreStateEnums, TransferWorkshopStoreTypeEnums } from "src/app/enum/transfer-workshop-store-enum";

export class TransferWorkshopStoreModel {
  transferWorkshopStoreId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  dateTransferWorkshopStore: Date = new Date();
  transferWorkshopStoreState: number = TransferWorkshopStoreStateEnums.open;
  type: number = TransferWorkshopStoreTypeEnums.cleaning;
  swBlock: boolean = false;
  observation: string | null = null;
  mechanicId: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}